const topbar = {
    docs: 'Docs',
    help: 'ช่วยเหลือ',
};
export default Object.freeze(topbar);
